import { useLayoutEffect, useState } from 'react';
import { useMatches } from '@tanstack/react-location';

function createRegexFromPattern(pattern: string): RegExp {
  const modifiedPattern = pattern.replace(/:\w+/g, '([^/]+)');

  const regexPattern = `^${modifiedPattern}/?$`;

  return new RegExp(regexPattern);
}

function matchPattern(pattern: string, path: string): boolean {
  const regex = createRegexFromPattern(pattern);
  return regex.test(path);
}

export const useActiveContentPanel = (path?: string) => {
  const matches = useMatches();
  const [isActive, setIsActive] = useState(false);

  useLayoutEffect(() => {
    if (path) {
      const isMatch = matches.some((match) => matchPattern(path, match.id));
      setIsActive(isMatch);
    } else {
      setIsActive(matches.length >= 2);
    }
  }, [matches.length]);

  return isActive;
};
